import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mmdanrh9jf: FaireBrandEntity = {
  token: "b_mmdanrh9jf",
  type: "brand",
  name: "emily lex studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/35bfa1a8b46082b0bbbe908207fa90143647788b26809320684e927d8f788b2a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8e2264b23d5794e2bd70f7bc2d44ccace27b09886dd80d8a3fdc32297e684ca7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/35bfa1a8b46082b0bbbe908207fa90143647788b26809320684e927d8f788b2a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8e2264b23d5794e2bd70f7bc2d44ccace27b09886dd80d8a3fdc32297e684ca7.jpeg",
  location: "Gig Harbor, WA, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 1354,
  isTopShop: true,
  isInsider: true,
  description:
    "There's something lovely about using pretty things to do everyday things - whether that's writing a note, planning your day, making space for creativity, or remembering what's true - we hope you are delighted and encouraged by all we offer at Emily Lex Studio. \n\nWith scratchy pencil sketches and pretty watercolor puddles, Emily creates cheerful illustrations that make their way onto our original papergoods + gifts. \n\nAll packages ship from our Gig Harbor, Washington location. ",
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:10:38.289Z",
    importedBy: "entity-db-cli",
  },
};
